import { useGlobalStore } from '@digiwedge/global-state';

const STORAGE_KEY = 'yolo-pricing-customer-id';

const readEnv = (key: string): string | undefined => {
  const runtime = (globalThis as { __YOLO_SHOP_ENV__?: Record<string, string | undefined> }).__YOLO_SHOP_ENV__;
  if (runtime?.[key]) return runtime[key];
  const legacy = (globalThis as { __ENV__?: Record<string, string | undefined> }).__ENV__;
  if (legacy?.[key]) return legacy[key];
  const proc = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process?.env;
  return proc?.[key];
};

const extractProfileCustomerId = (): string | undefined => {
  const profile = useGlobalStore.getState().profile as Record<string, unknown> | null;
  if (!profile) return undefined;

  const candidates = [
    profile['customerExternalId'],
    profile['haloClientId'],
    profile['pricingCustomerId'],
  ];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim().length > 0) {
      return candidate.trim();
    }
    if (typeof candidate === 'number' && Number.isFinite(candidate)) {
      return String(candidate);
    }
  }

  return undefined;
};

export const getPricingCustomerId = (): string | undefined => {
  const profileValue = extractProfileCustomerId();
  if (profileValue) return profileValue;

  if (typeof window === 'undefined') {
    return readEnv('VITE_YOLO_CUSTOMER_ID')?.trim() || undefined;
  }

  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && stored.trim().length > 0) return stored.trim();

  return readEnv('VITE_YOLO_CUSTOMER_ID')?.trim() || undefined;
};

export const setPricingCustomerId = (value?: string): void => {
  if (typeof window === 'undefined') return;
  if (value && value.trim().length > 0) {
    window.localStorage.setItem(STORAGE_KEY, value.trim());
  } else {
    window.localStorage.removeItem(STORAGE_KEY);
  }
};
